import React from 'react';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {filter, isEqual} from 'lodash';
import ListItem from '@material-ui/core/ListItem';
import {I18n} from 'react-redux-i18n';
import AutoCompleteInput from '../../../Form/AutoCompleteInput';
import Chips from '../../../components/Chips';
import {predict, setChips} from '../HealthFiltersActions';
import {isMobile} from '../../../app/configuration/util';

class MainFilter extends React.Component {
  constructor(props) {
    super(props);
    const {chips} = props.applied;
    this.state = {
      over: false,
      focused: false,
      chips
    };
  }

  onMouseOver = () => this.setState({over: true});
  onMouseOut = () => this.setState({over: false});
  onBlur = () => this.setState({focused: false});
  onFocus = () => this.setState({focused: true});

  setChips = ({chips}) => {
    this.setState({chips}, () => this.props.setChips(chips));
  }

  handleOnFetchAutocomplete = value => {
    if (this.fetchTimer) {
      window.clearTimeout(this.fetchTimer);
    }

    this.fetchTimer = window.setTimeout(
      () => {
        this.props.predict({text: value});
        this.fetchTimer = null;
      },
      550
    );
  }

  handleOnRemoveChip = (event, chip) => {
    const chips = filter(this.state.chips, item => !isEqual(item, chip));
    this.setChips({chips});
  }


  handleOnSelectedAutocomplete = (event, {suggestion}) => {
    const {type, name} = suggestion;
    const currentChips = filter(this.state.chips, chip => chip.name !== type);
    currentChips.push({name: type, label: name});
    this.setChips({chips: currentChips});
  }

  getChipsComponent = () => {
    let chipClasses = ['desktopfields__chipscont'];
    if (!this.props.isMobile) {
      const {over, focused} = this.state;

      if (focused) {
        chipClasses.push('focused');
      } else if (over) {
        chipClasses.push('over');
      }
      chipClasses = chipClasses.join(' ');
    }
    return (
      <div className={classnames(chipClasses)}>
        <Chips
          list={this.props.applied.chips}
          onRemove={this.handleOnRemoveChip}
          id="filterVehicleSerialNumber"
        />
      </div>
    );
  }

  getAutocompleteComponent = () => {
    return (
      <AutoCompleteInput
        placeholder={I18n.t('filter.vehicleSerialNumber.placeholder')}
        id="txtVehicleIdentification"
        list={this.props.chipsOptions.entries}
        onSelect={this.handleOnSelectedAutocomplete}
        onFetchRequested={this.handleOnFetchAutocomplete}
        isLoading={this.props.chipsOptions.loading}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}
      />
    );
  }

  getContainerClasses = () => {
    return this.props.isMobile ? 'bringontop desktopfields__mainsearch desktopfields__dvrhealthsearch' : 'dtcontainer';
  };

  render() {
    return (
      <div className={this.getContainerClasses()}>
        {
          this.props.isMobile &&
          <div>
            <ListItem>
              {this.getChipsComponent()}
            </ListItem>
            <ListItem>
              {this.getAutocompleteComponent()}
            </ListItem>
          </div>
        }

        {
          !this.props.isMobile &&
          <ListItem className="bringontop desktopfields__mainsearch desktopfields__dvrhealthsearch">
            {this.getChipsComponent()}
            {this.getAutocompleteComponent()}
          </ListItem>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state.i18n.locale,
  ...state.dvrFilter,
  isMobile: isMobile(state)
});

export default connect(mapStateToProps, {
  predict,
  setChips
})(MainFilter);
